export const DEFAULT_PRECISION = 14;

export default {
  DEFAULT_PRECISION,
};
